import { useDispatch } from 'react-redux';
import { formatInTimeZone } from 'date-fns-tz';

import { Chip } from '@material-ui/core';

import {
  setActiveTime,
  setAppointmentScheduleTime,
} from 'redux/slices/spot.slice';

import { useStyles } from './ChipTimePicker.styles';

const ChipTimePicker = ({ data, activeTime }) => {
  const dispatch = useDispatch();

  const classes = useStyles({
    isSelected: data.time === activeTime.time && activeTime.isSelected,
  });

  const label = formatInTimeZone(
    new Date(data.time),
    'America/Mexico_City',
    'HH:mm',
  );

  const onClickHandler = () => {
    dispatch(setAppointmentScheduleTime(data.time));
    if (data.time === activeTime.time) {
      dispatch(
        setActiveTime({
          ...activeTime,
          isSelected: !activeTime.isSelected,
        }),
      );
    } else {
      dispatch(
        setActiveTime({
          ...data,
          isSelected: true,
        }),
      );
    }
  };

  return (
    <Chip
      classes={{ root: classes.chip }}
      label={label}
      disabled={!data.isAvailable}
      onClick={onClickHandler}
    />
  );
};

export default ChipTimePicker;
